export type Retentions = Record<string, number>

export const retentions = {
  month: 3.72,
  quarter: 2.54,
  week: 6.01,
  year: 1.41,
} satisfies Retentions
